/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createInterviewBookingTokensInputMeetingLocationTypeSchema = z.enum([
	'jobilla_meet',
	'google_meet',
	'teams',
	'zoom',
	'phone',
	'in_person',
	'custom',
])

export type CreateInterviewBookingTokensInputMeetingLocationTypeSchema = z.infer<
	typeof createInterviewBookingTokensInputMeetingLocationTypeSchema
>
